// Constants
import { HttpStatus, HttpStatusText } from "@ms/uno-constants/lib/local/HttpStatusConstants";
import { generateAjaxClientError } from "../../utilities/ServiceUtilities";
import { TraceLevel } from "@ms/uno-telemetry/lib/local/events/Trace.event";
/**
 * Implementation of the Auth Service that simply relies on the host adaptor to provide the access token
 */ export class HostAdaptorAuthService {
    async fetchAccessTokenAsync(parameters) {
        const { claims, silent } = parameters;
        try {
            if ("resource" in parameters) {
                const hostToken = await this.hostAdaptor.getAccessToken(parameters.resource, claims, silent);
                return hostToken;
            } else {
                const hostToken = await this.hostAdaptor.getAccessTokenForScopes(parameters.scopes, claims, silent);
                return hostToken;
            }
        } catch (error) {
            if (this.configProvider().flights.EnableErrorMessageLogging) {
                // We just need to wrap this error into a failed request result
                this.loggers.traceLogger.logTrace(0x1e19f78c /* tag_4g54m */ , TraceLevel.Warning, `Could not get an auth token: [ErrorType=${error?.name}]`);
                const errorText = "Could not get an access token: HostedAdaptorAuthService";
                const failureResult = generateAjaxClientError(new Response(errorText, {
                    status: HttpStatus.Unauthorized,
                    statusText: HttpStatusText.Unauthorized
                }), errorText);
                return Promise.reject(failureResult);
            } else {
                // If error message logging is disabled, we throw the error directly
                return Promise.reject(error);
            }
        }
    }
    constructor(loggers, hostAdaptor, configProvider){
        this.loggers = loggers;
        this.hostAdaptor = hostAdaptor;
        this.configProvider = configProvider;
    }
}
